import {styled} from "@mui/material/styles";
import {Box, Button} from "@mui/material";

export const StyledLogo = styled(Box)({
  color: '#3b3b3b',
  fontFamily: "AvenirNext-Medium",
  fontSize: 20,
});

export const StyledStepText = styled(Box)({
  fontFamily: 'AvenirNext-DemiBold',
  color: '#887fff',
  fontSize: 10,
  letterSpacing: 1
});

export const StyledStepAction = styled(Box)({
  backgroundColor: '#fff',
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0
});

export const StyledTrainingBody = styled(Box)({
  height: 'calc(100vh - 160px)',
});

const buttonStyle = {
  borderWidth: 2,
  borderRadius: 20,
  borderStyle: 'solid',
  '&:hover': {
    borderWidth: 2,
  },
};

export const StyledActionButton = styled(Button)({
  ...buttonStyle,
  '& .MuiButton-root': {
    fontSize: 16,
  }
});

export const StyledError = styled(Box)({
  color: '#f00',
  fontStyle: 'italic',
  fontFamily: "AvenirNext-DemiBold",
  fontWeight: 500,
});
